import React, { useState } from 'react';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';
import { SharedStyles as Shared } from '@screens/Authenticated/Property/sharedStyles';
import { Styles as UStyles } from '@screens/Authenticated/Users/UserRegisterScreen/style';
import { Agent } from '@screens/Authenticated/Users/UserList/agentData';
import { useNavigate } from 'react-router-dom';

const ConfigUsersCreateScreen: React.FC = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState<
    Omit<Agent, 'id' | 'createdAt' | 'updatedAt'>
  >({
    userType: 'Corretor',
    agentName: '',
    agentPhoto: '',
    phone: '',
    email: '',
    agentCode: '',
    propertiesManaged: []
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: integrar com API quando disponível
    console.log('Novo usuário:', formData);
    navigate('/area-do-corretor/configuracoes/usuarios');
  };

  return (
    <AuthenticatedLayout>
      <Shared.PageSection>
        <h1>Cadastrar Usuários</h1>
        <Shared.RectangleBar />
        <form onSubmit={handleSubmit}>
          <UStyles.FormSection>
            <UStyles.InputContainer>
              <UStyles.Label>Nome Completo *</UStyles.Label>
              <UStyles.Input
                name="agentName"
                value={formData.agentName}
                onChange={handleChange}
                required
              />
            </UStyles.InputContainer>

            <UStyles.InputContainer>
              <UStyles.Label>Tipo de Usuário *</UStyles.Label>
              <UStyles.Select
                name="userType"
                value={formData.userType}
                onChange={handleChange}
                required>
                <option value="Corretor">Corretor</option>
                <option value="Secretária">Secretária</option>
                <option value="Administrador">Administrador</option>
                <option value="Proprietário">Proprietário</option>
              </UStyles.Select>
            </UStyles.InputContainer>

            <UStyles.InputContainer>
              <UStyles.Label>Código *</UStyles.Label>
              <UStyles.Input
                name="agentCode"
                value={formData.agentCode}
                onChange={handleChange}
                required
              />
            </UStyles.InputContainer>
          </UStyles.FormSection>

          <UStyles.FormSection>
            <UStyles.InputContainer>
              <UStyles.Label>Telefone *</UStyles.Label>
              <UStyles.Input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </UStyles.InputContainer>

            <UStyles.InputContainer>
              <UStyles.Label>E-mail *</UStyles.Label>
              <UStyles.Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </UStyles.InputContainer>
          </UStyles.FormSection>

          <UStyles.FormSection>
            <UStyles.InputContainer>
              <UStyles.Label>URL da Foto</UStyles.Label>
              <UStyles.Input
                type="url"
                name="agentPhoto"
                value={formData.agentPhoto}
                onChange={handleChange}
              />
            </UStyles.InputContainer>

            {formData.agentPhoto && (
              <div style={{ marginLeft: '20px' }}>
                <img
                  src={formData.agentPhoto}
                  alt="Preview"
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            )}
          </UStyles.FormSection>

          <UStyles.FormSection>
            <UStyles.Button type="submit">SALVAR</UStyles.Button>
            <UStyles.CancelButton type="button" onClick={() => navigate(-1)}>
              CANCELAR
            </UStyles.CancelButton>
          </UStyles.FormSection>
        </form>
      </Shared.PageSection>
    </AuthenticatedLayout>
  );
};

export default ConfigUsersCreateScreen;
